<template>
  <div class="base-container">
    <navbar />
    <incomplete-registration-alert />
    <bottom-navigation />
    <router-view></router-view>
  </div>
</template>

<script>
import BaseLayoutNavbar from "@/layouts/BaseLayoutNavbar.vue";
import BaseLayoutBottomNavigation from "@/layouts/BaseLayoutBottomNavigation.vue";
import IncompleteRegistrationAlert from "@/components/IncompleteRegistrationAlert.vue";

export default {
  name: "base-layout",
  components: {
    navbar: BaseLayoutNavbar,
    "bottom-navigation": BaseLayoutBottomNavigation,
    IncompleteRegistrationAlert,
  },
};
</script>
